import React from "react";
import { Route } from "react-router-dom";
import { ProjectCard } from "./ProjectCard";
import { ProjectEditDialog } from "./project-edit-dialog/ProjectEditDialog";
import { ProjectUIProvider } from "./ProjectUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { RoleChecker } from "../../../RoleChecker";
import { ProjectDeleteDialog } from "./project-delete-dialog/ProjectDeleteDialog";

export function ProjectPage({ history }) {
  const projectUIEvents = {
    newProjectButtonClick: () => {
      history.push("/_distribution/project/new");
    },
    openEditProjectPage: (id) => {
      history.push(`/_distribution/project/${id}/edit`);
    },
    openManageProjectPage: (id) => {
      history.push(`/_distribution/project/${id}/manage`);
    },
  };

  return (
    <ProjectUIProvider projectUIEvents={projectUIEvents}>
      {/* <PrivateRoute
        // role={RoleChecker("Create", "benefis_category")}
        role={true}
        component={ProjectEditDialog}
        path="/project/new"
      />
      <PrivateRoute
        // role={RoleChecker("Edit", "benefis_category")}
        role={true}
        component={ProjectEditDialog}
        path="/project/:id/edit"
      />
      <PrivateRoute
        // role={RoleChecker("Delete", "benefis_category")}
        role={true}
        component={ProjectEditDialog}
        path="/project/:id/edit"
      /> */}

      {/* <Route path="/project/new">
        {({ history, match }) => (
          <ProjectEditDialog
            show={match != null}
            onHide={() => {
              history.push("/project");
            }}
          />
        )}
      </Route> */}
      {/* <Route path="/project/:id/edit">
        {({ history, match }) => (
          <ProjectEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/project");
            }}
          />
        )}
      </Route> */}
      <Route path="/_distribution/project/:id/delete">
        {({ history, match }) => (
          <ProjectDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/project");
            }}
          />
        )}
      </Route>

      <ProjectCard />
    </ProjectUIProvider>
  );
}
